import { Grid, Paper, Typography, TextField, Button } from "@material-ui/core";
import { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { submitSRPLead } from "../../Actions";
import SlotMachine from "./slotMachine";

export default function VegasMarketing(props) {
  const history = useHistory();
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    city: "",
    state: "",
    phone: "",
    email: ""
  });
  const [modalOpen, setModalOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value || ''
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let allFilled = true;
    const parsedFormData = { ...formData };

    Object.keys(formData).forEach(key => {
      if (!formData[key]) {
        allFilled = false;
        return;
      };

      parsedFormData[key] = formData[key]?.trim() || null;
    });

    if (!allFilled) {
      alert("Please fill out all fields before submitting.");
      return;
    }

    setModalOpen(true);
    submitSRPLead(parsedFormData);
  };

  return (
    <div style={{margin: "100px 10px 20px"}}>
      <Paper elevation={15} style={{padding: "10px 10px 20px"}}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4">Thanks for Stopping by Our Booth!</Typography>
            <Typography variant="body1" style={{marginTop: "10px"}}>Please fill out the form below to enter our Spin to Win contest!</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              InputLabelProps={{
                shrink: true,
              }} 
              label="Name" 
              name="name" 
              placeholder="First Last"
              value={formData.name} 
              onChange={handleChange} 
              required={true}
              variant="outlined" 
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              InputLabelProps={{
                shrink: true,
              }} 
              label="Phone" 
              name="phone" 
              type="tel" 
              placeholder="123-456-7890"
              value={formData.phone} 
              onChange={handleChange}
              required={true} 
              variant="outlined" 
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              InputLabelProps={{
                shrink: true,
              }} 
              label="Email" 
              name="email" 
              type="email" 
              placeholder="test@test.com"
              value={formData.email} 
              onChange={handleChange} 
              required={true}
              variant="outlined" 
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              InputLabelProps={{
                shrink: true,
              }} 
              label="Company" 
              name="company" 
              placeholder="Showroom Pricing"
              value={formData.company} 
              onChange={handleChange} 
              required={true}
              variant="outlined" 
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              InputLabelProps={{
                shrink: true,
              }} 
              label="City" 
              name="city" 
              placeholder="Vegas" 
              value={formData.city} 
              onChange={handleChange} 
              required={true}
              variant="outlined" 
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              InputLabelProps={{
                shrink: true,
              }} 
              label="State" 
              name="state" 
              placeholder="NV" 
              value={formData.state} 
              onChange={handleChange} 
              required={true}
              variant="outlined" 
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" style={{marginTop: "10px", color: "#28C4FC", backgroundColor: "#142E3E"}} onClick={handleSubmit}>Submit and Spin</Button>
          </Grid>
        </Grid>
      </Paper>

      <SlotMachine 
        isOpen={modalOpen} 
        onClose={() => {
          setModalOpen(false);
          history.goBack();
        }} 
      />
    </div>
  )
}